import { IconCross } from '@components/icons/icon-cross';
import { Modal } from '@components/modals/modal';
import classNames from 'classnames';

import type { PrintModalProps } from './print-modal.type';

export const PrintModal = ({ isOpen, toggleModal, file, isMobile }: PrintModalProps) => {
  return (
    <Modal isOpen={isOpen} handleClose={() => toggleModal(true)}>
      <div
        className={classNames('flex flex-col gap-3 w-full p-4 h-[80vh]', {
          'h-[80vh]': !isMobile,
          'h-[30vh]': isMobile,
        })}>
        <button className='self-end' type='button' onClick={() => toggleModal(false)}>
          <IconCross className='w-4 h-4 text-primary' aria-label='Close modal' />
        </button>
        {!isMobile && (
          <div className='h-full w-full flex items-center justify-center'>
            <embed
              aria-label={'pdf'}
              title='PdfFile'
              src={`data:application/pdf;base64,${file}`}
              type='application/pdf'
              width='100%'
              height='100%'
            />
          </div>
        )}
      </div>
    </Modal>
  );
};
